{
  "title": "Ayarlar",
  "tabs": {
    "provider": "Sağlayıcı",
    "connection": "Bağlan",
    "appearance": "Görünüm",
    "agent": "Vekil",
    "features": "Özellikler",
    "mcp": "MCP"
  },
  "appearance": {
    "themeHeading": "Tema",
    "themeLight": "Açık",
    "themeDark": "Koyu",
    "themeSystem": "Sistem",
    "themeSystemHint": "Sistem, işletim sistemi düzeyindeki açık/koyu tercihinizi izler.",
    "preferencesHeading": "Tercihler",
    "compactDensity": "Sıkışık yoğunluk",
    "compactDensityHint": "Sohbet boyunca daha dar aralıklar.",
    "soundOnComplete": "Tamamlanınca ses çal",
    "soundOnCompleteHint": "Bir çalışma bitince hafif bir çan sesi çal.",
    "titleAnimation": "Başlık animasyonu",
    "titleAnimationHint": "CLI'da animasyonlu terminal başlığını göster.",
    "languageHeading": "Dil",
    "languageLabel": "Arayüz dili",
    "languageHint": "Yalnızca arayüz metnini değiştirir. Promptlar, beceriler ve model çıktısı etkilenmez."
  },
  "model": {
    "heading": "Model",
    "loading": "Modeller yükleniyor...",
    "notFound": "Bu sağlayıcı için model bulunamadı. Katalog boş olabilir veya hâlâ yükleniyor olabilir.",
    "selectProviderFirst": "Önce bir sağlayıcı seçin",
    "context": "{{count}}k bağlam"
  },
  "connection": {
    "wsUrlLabel": "WebSocket Sunucu URL'si",
    "wsUrlPlaceholder": "ws://localhost:3457",
    "wsUrlHint": "Vekil WebSocket sunucusunun URL'si. Sunucu CLI ile birlikte çalışır.",
    "startingHeading": "WebSocket Sunucusunu Başlatma",
    "startingBody": "Bağımsız: repo kökünden ./dev.ps1 çalıştırın veya wstackui başlatmadan önce WS_HOST/WS_PORT ayarlayın. Veya CLI ile birlikte: wstack --webui."
  },
  "provider": {
    "subscriptionHeading": "Abonelik girişi",
    "apiKeysHeading": "API anahtarı sağlayıcıları",
    "apiKeysBody": "Katalogdan bir sağlayıcı seçip API anahtarı ekleyin veya kayıtlı sağlayıcıları yönetin.",
    "tabCatalog": "Katalog",
    "tabSaved": "Kayıtlı ({{count}})",
    "searchPlaceholder": "{{count}} sağlayıcıda ara (ad / kimlik / aile)…",
    "loadingCatalog": "Katalog yükleniyor...",
    "noMatch": "\"{{query}}\" ile eşleşen sağlayıcı yok.",
    "configured": "Yapılandırıldı",
    "reachable": "Erişilebilir",
    "envVar": "ENV: {{var}}",
    "modelCount_one": "{{count}} model",
    "modelCount_other": "{{count}} model",
    "keyPlaceholder": "{{name}} API anahtarı",
    "orEnv": "Veya bunun yerine ortamda {{env}} ayarlayın.",
    "addApiKey": "API anahtarı ekle",
    "manageKeys": "API anahtarlarınızı ve sağlayıcı yapılandırmalarınızı yönetin",
    "addProvider": "Sağlayıcı Ekle",
    "addCustomHeading": "Özel Sağlayıcı Ekle",
    "localServers": "Yerel sunucular — doldurmak için tıklayın:",
    "providerIdPlaceholder": "Sağlayıcı kimliği (örn. my-llm-server)",
    "apiKeyOptionalPlaceholder": "API Anahtarı (isteğe bağlı)",
    "noSaved": "Henüz kayıtlı sağlayıcı yok",
    "noSavedHint": "Başlamak için bir sağlayıcı ekleyin",
    "apiKeysLabel": "API Anahtarları",
    "addKey": "Anahtar Ekle",
    "noKeys": "Yapılandırılmış anahtar yok",
    "active": "Etkin",
    "setActive": "Etkin Yap",
    "keyLabelPlaceholder": "Anahtar etiketi (örn. default, production)",
    "apiKeyPlaceholder": "API anahtarı",
    "saveKey": "Anahtarı Kaydet",
    "savedToast": "{{name}} için anahtar kaydedildi"
  },
  "mcp": {
    "status": {
      "connected": "Bağlandı",
      "connecting": "Bağlanıyor",
      "sleeping": "Uyuyor",
      "discovering": "Keşfediliyor",
      "error": "Hata",
      "stopped": "Durduruldu",
      "unknown": "Bilinmiyor"
    },
    "disabled": "MCP sunucuları devre dışı.",
    "wakeTitle": "Sunucuyu uyandır",
    "sleepTitle": "Sunucuyu uyut",
    "discoverTitle": "Araçları keşfet",
    "editTitle": "Düzenle",
    "removeTitle": "Kaldır",
    "statusLabel": "Durum:",
    "enabledLabel": "Etkin:",
    "yes": "Evet",
    "no": "Hayır",
    "descriptionLabel": "Açıklama:",
    "pidLabel": "PID:",
    "errorLabel": "Hata:",
    "toolsLabel": "Araçlar ({{count}}):",
    "noTools": "Henüz araç keşfedilmedi",
    "serverNameRequired": "Sunucu adı zorunludur",
    "dialogTitleEdit": "MCP Sunucusunu Düzenle",
    "dialogTitleAdd": "MCP Sunucusu Ekle",
    "dialogTitleAddCustom": "Özel MCP Sunucusu Ekle",
    "fieldName": "Ad",
    "fieldNamePlaceholder": "örn., github, filesystem",
    "fieldTransport": "Aktarım",
    "fieldUrl": "URL",
    "fieldCommand": "Komut",
    "fieldCommandPlaceholder": "örn., npx",
    "fieldArgs": "Argümanlar",
    "fieldArgsHint": "(boşlukla ayrılmış)",
    "fieldArgsPlaceholder": "örn., -y @modelcontextprotocol/server-github",
    "fieldEnv": "Ortam değişkenleri",
    "fieldEnvHint": "(KEY=değer, satır başına bir tane)",
    "fieldDescription": "Açıklama",
    "fieldDescriptionPlaceholder": "Depo erişimi için GitHub MCP sunucusu",
    "enableServer": "Sunucuyu etkinleştir",
    "lazyConnect": "Tembel bağlan",
    "lazyConnectHint": "(ilk araç çağrısına kadar başlatma; boştayken otomatik uyur)",
    "saveChanges": "Değişiklikleri Kaydet",
    "addServer": "Sunucu Ekle",
    "requires": "Gerektirir: {{vars}}",
    "added": "Eklendi",
    "heading": "MCP Sunucuları",
    "summary": "{{connected}} bağlı · {{sleeping}} uyuyor · {{total}} toplam",
    "addCustom": "Özel Ekle",
    "tabRecommended": "Önerilen",
    "tabServers": "Sunucular",
    "tabAddCustom": "Özel Ekle",
    "recommendedBody": "Popüler MCP sunucularını tek tıkla ekleyin. Yapılandırmayı öndoldurmak için Ekle'ye tıklayın, sonra onaylayın. Kimlik bilgisi gerektiren sunucuların kullanımdan önce ortam değişkenleri ayarlanmalıdır.",
    "loadingServers": "Sunucular yükleniyor...",
    "noServers": "Yapılandırılmış MCP sunucusu yok",
    "noServersHint": "Popüler sunucular eklemek için Önerilen sekmesine, kendi sunucunuz için Özel Ekle'ye geçin.",
    "addCustomBody": "stdio, SSE veya HTTP aktarımıyla özel bir MCP sunucusu yapılandırın.",
    "addCustomBodyHint": "Popüler sunucular için bunun yerine Önerilen sekmesini kullanın — her şey sizin için önceden yapılandırılmıştır.",
    "removeConfirmTitle": "\"{{name}}\" sunucusu kaldırılsın mı?",
    "removeConfirmBody": "Bu, MCP sunucusunu yapılandırmanızdan kaldırır.",
    "toastAdded": "\"{{name}}\" sunucusu eklendi",
    "toastRemoved": "\"{{name}}\" sunucusu kaldırıldı",
    "toastDiscovered": "\"{{name}}\" sunucusundan {{count}} araç keşfedildi",
    "toastSleeping": "\"{{name}}\" sunucusu artık uyuyor",
    "toastConnected": "\"{{name}}\" sunucusu bağlandı",
    "toastReconnected": "\"{{name}}\" sunucusu yeniden bağlandı",
    "toastDisconnected": "\"{{name}}\" sunucusu bağlantısı koptu: {{reason}}",
    "toastError": "\"{{name}}\" sunucusu hatası: {{error}}",
    "disabledHint": "Bu bölümü kullanmak için Özellikler sekmesindeki \"MCP sunucuları\" özellik bayrağını etkinleştirin."
  },
  "allowlist": {
    "title": "Kayıtlı izin listesi temizlensin mi?",
    "body_one": "Sabitlenen model {{provider}} için kaldırılacak. Model seçici models.dev kataloğuna geri dönecek.",
    "body_other": "{{count}} sabitlenen model {{provider}} için kaldırılacak. Model seçici models.dev kataloğuna geri dönecek.",
    "undoHint": "Onayladıktan sonra 8 saniye boyunca geri alabilirsiniz.",
    "keepTitle": "İzin listesini tut (Esc)",
    "clearTitle": "İzin listesini temizle (Enter)",
    "clear": "İzin listesini temizle"
  },
  "oauth": {
    "termsWarning": "Bir API anahtarı yerine abonelikle oturum açın. Aboneliği resmi istemcisi dışında kullanmak sağlayıcının Şartlarını ihlal edebilir — hesabınız hız sınırına takılabilir veya yasaklanabilir. API anahtarı programatik kullanım için onaylı yoldur.",
    "signIn": "Oturum aç",
    "waitingBrowser": "Oturum açmanız bekleniyor…",
    "openSignIn": "Oturum açma sayfasını aç",
    "pasteLoopbackBusy": "Loopback portu meşgul — yönlendirme URL'sini yapıştırın",
    "pasteCantReach": "Tarayıcı bu sunucuya ulaşamıyor mu? Yönlendirme URL'sini yapıştırın",
    "submit": "Gönder",
    "enterCode": "Bu kodu doğrulama sayfasına girin:",
    "openVerification": "Doğrulama sayfasını aç",
    "waitingCode": "Yetkilendirme bekleniyor…",
    "exchanging": "Tokenlar değiştiriliyor…",
    "fetchingModels": "Modeller getiriliyor…",
    "signedIn": "Oturum açıldı.",
    "signedInToast": "Oturum açıldı — {{provider}}",
    "signInFailed": "Oturum açma başarısız"
  },
  "agent": {
    "modelHeading": "Model",
    "autonomyHeading": "Otonomi ve Davranış",
    "autonomyModeLabel": "Otonomi modu",
    "autonomyModeHint": "Ajanın turlar arasında ne kadar bağımsız ilerlediği.",
    "autonomyModeOff": "Kapalı — tam manuel kontrol",
    "autonomyModeSuggest": "Öner — sonraki adımları önerir",
    "autonomyModeAuto": "Otomatik — kısa onay gecikmesi",
    "autonomyModeEternal": "Sonsuz — hedef bitene kadar otonom",
    "autonomyModeEternalParallel": "Sonsuz Paralel — çok-ajanlı filo",
    "autoProceedDelayLabel": "Otomatik ilerleme gecikmesi",
    "autoProceedDelayHint": "Otomatik modda ajan otomatik ilerlemeden önceki milisaniye. 0 = anında.",
    "yoloLabel": "YOLO modu",
    "yoloHint": "Araç onay istemlerini atla — ajan sormadan çalışır.",
    "refineHeading": "İstem İyileştirme",
    "enableRefineLabel": "İyileştirmeyi etkinleştir",
    "enableRefineHint": "Göndermeden önce istemleri yeniden yazar — daha net talimatlar, daha iyi sonuçlar.",
    "refineDelayLabel": "İyileştirme gecikmesi",
    "refineDelayHint": "İyileştirilmiş istem otomatik gönderilmeden önceki geri sayım.",
    "refineLanguageLabel": "İyileştirme dili",
    "refineLanguageHint": "Dilinizi koruyun veya model için İngilizceye çevirin.",
    "refineLanguageOriginal": "Orijinal — dilinizi koruyun",
    "refineLanguageEnglish": "İngilizce — İngilizceye çevir",
    "reasoningHeading": "Akıl Yürütme ve Önbellek",
    "reasoningModeLabel": "Akıl yürütme modu",
    "reasoningModeHint": "Modelin genişletilmiş düşünmeyi nasıl kullandığını kontrol edin. Otomatik = sağlayıcı varsayılanı.",
    "reasoningModeAuto": "Otomatik — sağlayıcı varsayılanı",
    "reasoningModeOn": "Açık — düşünmeyi zorla",
    "reasoningModeOff": "Kapalı — düşünmeyi kapat",
    "reasoningEffortLabel": "Akıl yürütme çabası",
    "reasoningEffortHint": "Modelin düşünmeye harcadığı işlem gücü. Yalnızca model desteklediğinde gönderilir.",
    "reasoningEffortNone": "Yok",
    "reasoningEffortMinimal": "Minimal",
    "reasoningEffortLow": "Düşük",
    "reasoningEffortMedium": "Orta",
    "reasoningEffortHigh": "Yüksek",
    "reasoningEffortXhigh": "Çok Yüksek",
    "reasoningEffortMax": "Maks",
    "preserveThinkingLabel": "Düşünmeyi koru",
    "preserveThinkingHint": "Bağlam sürekliliği için akıl yürütme bloklarını turlar arasında tut.",
    "cacheTtlLabel": "Önbellek TTL",
    "cacheTtlHint": "İstem önbelleği yaşam süresi. 1h yazmada pahalıdır ama tekrarlanan okumalarda tasarruf sağlar (Anthropic).",
    "cacheTtlDefault": "Varsayılan — sağlayıcı varsayılanı",
    "cacheTtl5m": "5 dakika",
    "cacheTtl1h": "1 saat",
    "capsHint": "Mevcut modelin ne desteklediğini kontrol etmek için wstack models caps kullanın. Desteklenmeyen ayarlar istek başına sessizce atlanır.",
    "fallbackHeading": "Model Yedekleri",
    "fallbackBody": "Aktif model hız sınırlarsa (429/529), 5xx hatası verirse veya takılırsa — kendi yeniden denemelerinden sonra — ajan bu zincirdeki bir sonraki modele geçer. Ayrıca SDD işçi alt-ajanları için varsayılan olarak kullanılır.",
    "autoFallbackLabel": "Otomatik yedek",
    "autoFallbackHint": "Yukarıdaki zincir boşsa, anahtarlı sağlayıcılarınızdan otomatik türet.",
    "favoritesOnlyLabel": "Sadece favoriler",
    "favoritesOnlyHint": "Otomatik yedek bir zincir türettiğinde, onu favori modellerinizle sınırlandır.",
    "profilesHeading": "Yedek Profilleri",
    "addProfile": "Ekle",
    "noProfiles": "Henüz adlandırılmış yedek profili yok.",
    "createDefault": "Aktif modelden varsayılan oluştur",
    "useChain": "Zinciri kullan",
    "setLeader": "Lideri ayarla",
    "profileEmpty": "Profil boş.",
    "favoritesHeading": "Favori Modeller",
    "favoritesEmpty": "Favoriler önce gösterilir ve otomatik yedeği kısıtlayabilir.",
    "routingHeading": "Model Yönlendirme",
    "routingRouteKey": "Model rotası anahtarı",
    "routingPhasesGroup": "Aşamalar",
    "routingRolesGroup": "{{label}} rolleri",
    "routingCustomGroup": "Özel mevcut rotalar",
    "routingTargetPlaceholder": "fallback1, provider/model veya boş",
    "routingSet": "Ayarla",
    "routingReasoningModeAria": "Yeni rota akıl yürütme modu",
    "routingReasoningEffortAria": "Yeni rota akıl yürütme çabası",
    "routingReasoningPreserveAria": "Yeni rota akıl yürütme koruması",
    "routingReasoningModeFor": "{{key}} için akıl yürütme modu",
    "routingReasoningEffortFor": "{{key}} için akıl yürütme çabası",
    "routingReasoningPreserveFor": "{{key}} için akıl yürütme koruması",
    "noRoutes": "Henüz model rotası yok.",
    "leaderModel": "lider model",
    "hqHeading": "HQ İstemcisi",
    "hqPublishingLabel": "HQ yayınlama",
    "hqPublishingHint": "Bu WebUI/istemci oturumunu WrongStack HQ'ya yayınlayın. Aynı makine istemcileri yerel HQ kimlik doğrulamasını otomatik keşfedebilir; uzak istemciler aşağıdaki URL/tokenı kullanır.",
    "hqUrlLabel": "HQ URL",
    "hqUrlHint": "Aynı makine otomatik keşfi için boş bırakın.",
    "hqTokenLabel": "HQ istemci tokenı",
    "executionHeading": "Yürütme",
    "maxIterationsLabel": "Çalışma başına maks iterasyon",
    "maxIterationsHint": "agent.run() başına LLM turu için sabit sınır.",
    "autoProceedMaxIterationsLabel": "Otomatik ilerleme maks iterasyon",
    "autoProceedMaxIterationsHint": "N iterasyondan sonra otomatik ilerlemeyi durdur. 0 = sınırsız.",
    "confirmExitLabel": "Çıkıştan önce onayla",
    "confirmExitHint": "İlk Ctrl+C işi iptal eder, ikincisi çıkışı onaylar.",
    "chimeLabel": "Tamamlanmada ses",
    "chimeHint": "Bir ajan çalışması bittiğinde terminal zili.",
    "fleetHeading": "Filo ve Akış",
    "streamFleetLabel": "Filo olaylarını akıt",
    "streamFleetHint": "Filo panelinde canlı alt-ajan etkinliğini göster.",
    "maxConcurrentLabel": "Maks eşzamanlı alt-ajan",
    "maxConcurrentHint": "Aynı anda çalışabilecek maks alt-ajan sayısı.",
    "nextPredictionLabel": "Sonraki adım tahmini",
    "nextPredictionHint": "Bir tur tamamlandıktan sonra olası sonraki adımları tahmin et.",
    "telegramHeading": "Telegram Bildirimleri",
    "telegramSessionEndLabel": "Oturum sonu",
    "telegramSessionEndHint": "Bir oturum bittiğinde özet gönder.",
    "telegramDelegateLabel": "Temsilci tamamlandı",
    "telegramDelegateHint": "Bir alt-ajan tamamlandığında insanlaştırılmış not gönder.",
    "telegramLongToolLabel": "Uzun süren araçlar",
    "telegramLongToolHint": "Bir araç {{ms}}ms aşarsa bildir. Devre dışı bırakmak için 0 ayarla.",
    "telegramChangesApply": "Değişiklikler hemen uygulanır.",
    "telegramNotConfigured": "Telegram yapılandırılmamış. Önce bir bot bağlamak için CLI'da /telegram-setup çalıştırın.",
    "addModelToProfile": "Profile modele ekle…",
    "addFavoriteModel": "Favori modele ekle…",
    "hqRawContentLabel": "Ham HQ içeriği",
    "hqRawContentHint": "HQ'ya sansürlenmiş önizlemeler yerine ham içerik önizlemeleri gönder."
  },
  "features": {
    "flagsHeading": "Özellik Bayrakları",
    "mcpLabel": "MCP sunucuları",
    "mcpHint": "Model Context Protocol entegrasyonlarını etkinleştir.",
    "pluginsLabel": "Eklentiler",
    "pluginsHint": "Kullanıcı tarafından yüklenen eklentileri yükle ve çalıştır.",
    "memoryLabel": "Bellek",
    "memoryHint": "Oturumlar arasında bilgileri kalıcı kıl ve hatırla.",
    "skillsLabel": "Beceriler",
    "skillsHint": "Alan özelinde beceri istemlerini yükle.",
    "modelsRegistryLabel": "Model kayıt defteri",
    "modelsRegistryHint": "Salayıcı keşfi için models.dev kataloğunu kullan.",
    "indexOnStartLabel": "Başlangıçta dizine ekle",
    "indexOnStartHint": "Oturum başlangıcında kod tabanı sembol dizinini oluştur.",
    "contextHeading": "Bağlam ve Hata Ayıklama",
    "autoCompactLabel": "Bağlamı otomatik sıkıştır",
    "autoCompactHint": "Sınırlara yakınken bağlam penceresini otomatik kırp.",
    "compactorStrategyLabel": "Sıkıştırma stratejisi",
    "compactorStrategyHint": "Bağlam çok büyüdüğünde nasıl sıkıştırılacağı.",
    "compactorStrategyHybrid": "Karma — hızlı kurallar (varsayılan)",
    "compactorStrategyIntelligent": "Akıllı — LLM özetleme",
    "compactorStrategySelective": "Seçici — LLM odaklı seçim",
    "contextModeLabel": "Bağlam modu",
    "contextModeHint": "Bağlam penceresi ilkesi — dengeli varsayılandır.",
    "contextModeBalanced": "Dengeli — normal bağlam kullanımı",
    "contextModeFrugal": "Tasarruflu — muhafazakar token kullanımı",
    "contextModeDeep": "Derin — karmaşık görevler için daha büyük bağlam",
    "contextModeArchival": "Arşiv — bağlam tutmayı maksimize et",
    "tokenSavingLabel": "Token tasarrufu modu",
    "tokenSavingHint": "Token kullanımını ne kadar agresif azaltacağı.",
    "tokenSavingOff": "Kapalı — token tasarrufu yok",
    "tokenSavingMinimal": "Minimal — temel optimizasyon",
    "tokenSavingLight": "Hafif — orta derecede azaltma",
    "tokenSavingMedium": "Orta — önemli tasarruflar",
    "tokenSavingAggressive": "Agresif — maksimum sıkıştırma",
    "logLevelLabel": "Günlük seviyesi",
    "logLevelHint": "Sunucu tarafı günlükleme için minimum şiddet.",
    "logLevelDebug": "Hata ayıkla — her şey",
    "logLevelInfo": "Bilgi — normal akış",
    "logLevelWarn": "Uyarı — sadece sorunlar",
    "logLevelError": "Hata — sadece başarısızlıklar",
    "auditLevelLabel": "Denetim seviyesi",
    "auditLevelHint": "Oturum denetim günlükleri için ayrıntı seviyesi.",
    "auditLevelMinimal": "Minimal — sadece hatalar",
    "auditLevelStandard": "Standart — araç çağrıları + hatalar",
    "auditLevelFull": "Tam — her olay (büyük günlükler)"
  },
  "toast": {
    "switchingTo": "{{provider}} / {{model}} modeline geçiliyor…",
    "fallbackExists": "\"{{name}}\" yedek profili zaten var",
    "selectProviderModelFirst": "Önce bir sağlayıcı ve model seçin",
    "defaultProfileCreated": "Varsayılan yedek profili oluşturuldu",
    "profileEmpty": "\"{{name}}\" yedek profili boş",
    "leaderSetFrom": "Lider {{name}} adından ayarlandı"
  }
}
